import {fileConfig} from "./file.config";
import {audienceConfig} from "./audience.config";
import {zoneConfig} from "./zone.config";

export const appConfig = {
    statuses: [
        {key: 'active', value: 1},
        {key: 'inactive', value: 0}
    ],
    fileConfig: fileConfig,
    audienceConfig: audienceConfig,
    zoneConfig: zoneConfig,
    listApp: {
        contentInsight: {
            url: 'https://ci.admicro.vn/',
            image: './assets/styles/default/images/creativity.png'
        },
        brandsafety: {
            url: 'https://safety.admicro.vn/app/',
            image: './assets/styles/default/images/logo-brand-safety.png'
        },
        dmp: {
            url: 'https://dmp.admicro.vn/',
            image: './assets/styles/default/images/platform.png'
        },
        inventoryTrading: {
            url: 'https://inventory-trading.admicro.vn/',
            image: './assets/styles/default/images/logo-mini-black.svg'
        }
    }
}
